module.exports = __webpack_public_path__ + "img/311.6f220e99.png";